module.exports = __webpack_public_path__ + "img/icono_clases.d9198ea9.svg";